export enum CommissionTypeEnum {
	Fixed = 1,
	Variable = 2,
}
